export default {
    methods: {
      updateRoute(name, params) {
        this.$router.push({ name, params });
      }
    }
  }